import { render, staticRenderFns } from "./pelepasandokumensebagiansettled.vue?vue&type=template&id=e8b20fd0&"
import script from "./pelepasandokumensebagiansettled.vue?vue&type=script&lang=js&"
export * from "./pelepasandokumensebagiansettled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports